module.exports = "https://cdn.littlereply.com/tt/resource/load-roll.cdc6bcf7dab0cf6b71ed9549620cf20a.png";